export default {
    apiKey: "AIzaSyDr4TEGVHupWe9ekH47-D2Q1RzA_Vq3ufo",
    authDomain: "one-night-wereworlf.firebaseapp.com",
    databaseURL: "https://one-night-wereworlf.firebaseio.com",
    projectId: "one-night-wereworlf",
    storageBucket: "one-night-wereworlf.appspot.com",
    messagingSenderId: "656088024469",
    appId: "1:656088024469:web:e6caaf02e393824eb4629c"
}